// Only Safari can decode HEIC, so other browsers get a JPEG converted client-side.
const cache = {};
const ready = {};

export function isHeic(url) {
    return /\.hei[cf]$/i.test((url || "").split("?")[0]);
}

export function toJpegUrl(url) {
    if (!cache[url]) {
        cache[url] = Promise.all([
            import("heic2any"),
            // no-store: a copy cached by a plain <a>/<img> request has no CORS headers and would make fetch fail
            fetch(url, { cache: "no-store" }).then(res => {
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                return res.blob();
            })
        ])
            .then(([{ default: heic2any }, blob]) => heic2any({ blob, toType: "image/jpeg", quality: 0.8 }))
            .then(jpeg => (ready[url] = URL.createObjectURL(Array.isArray(jpeg) ? jpeg[0] : jpeg)))
            .catch(err => {
                delete cache[url];
                throw err;
            });
    }
    return cache[url];
}

// Click handler for a target="_blank" media link: shows the converted JPEG instead of downloading the raw HEIC.
export function previewMedia(event, url) {
    if (!isHeic(url)) return;
    // Usual case: the thumbnail already converted it, so the link just follows the JPEG natively.
    if (ready[url]) {
        event.currentTarget.href = ready[url];
        return;
    }
    // Still converting: open the tab now, while the click still counts for the popup blocker. Blocked → plain download.
    const win = window.open("", "_blank");
    if (!win) return;
    event.preventDefault();
    toJpegUrl(url)
        .then(jpeg => (win.location.href = jpeg))
        .catch(() => (win.location.href = url));
}
